/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_EDITRESEARCHERDATAGENPOOL, EDITRESEARCHERDATAGENPOOL_RECEIVED } = constants.EditResearcherDataGenPoolConstants;

export default {
  REQUEST_EDITRESEARCHERDATAGENPOOL,
  EDITRESEARCHERDATAGENPOOL_RECEIVED,

  requestEditResearcherGenPoolData: payload => ({
  type: REQUEST_EDITRESEARCHERDATAGENPOOL,
    payload
  }),
  EditResearcherGenPoolDataReceived: () => ({
    type: EDITRESEARCHERDATAGENPOOL_RECEIVED
  })
};
